'use client';

// Datadog RUM + browser logs init. Rendered once at the root of
// `src/app/layout.tsx`. Uses `useEffect` so init only runs on the client
// (the SDKs touch `window`), and guards on the public tokens so local dev
// without Datadog env vars is a no-op.

import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

let initialized = false;

function initDatadog(): void {
  if (initialized) return;

  const applicationId = process.env.NEXT_PUBLIC_DD_APPLICATION_ID;
  const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
  if (!applicationId || !clientToken) {
    return;
  }

  const site = process.env.NEXT_PUBLIC_DD_SITE || 'datadoghq.com';
  const env = process.env.NEXT_PUBLIC_VERCEL_ENV || 'development';
  const version = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service: 'recreated',
    env,
    version,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogLogs.init({
    clientToken,
    site,
    service: 'recreated',
    env,
    version,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  initialized = true;
}

export function DatadogInit(): null {
  useEffect(() => {
    initDatadog();
  }, []);

  return null;
}
